import { StaffLayout } from "@/components/layouts/staff-layout"
import { SupplyLedger, type SupplyLedgerProps } from "@/features/staff/inventory/supply-ledger"

export default function StaffLocationManageSuppliesShow(props: SupplyLedgerProps) {
  return (
    <StaffLayout>
      <SupplyLedger {...props} />
    </StaffLayout>
  )
}
